import PropTypes from 'prop-types';

const addressDataModel = () => {
  PropTypes.shape({
    geometry: PropTypes.shape({
      location: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number
      }),
      viewport: PropTypes.shape({
        northeast: PropTypes.shape({
          lat: PropTypes.number,
          lng: PropTypes.number
        }),
        southwest: PropTypes.shape({
          lat: PropTypes.number,
          lng: PropTypes.number
        }),
        east: PropTypes.number,
        south: PropTypes.number,
        west: PropTypes.number,
        north: PropTypes.number
      }),
      bounds: PropTypes.shape({
        east: PropTypes.number,
        south: PropTypes.number,
        west: PropTypes.number,
        north: PropTypes.number
      })
    }),
    addressComponents: PropTypes.arrayOf(
      PropTypes.shape({
        types: PropTypes.arrayOf(PropTypes.string),
        shortName: PropTypes.string,
        longName: PropTypes.string
      })
    ),
    formattedAddress: PropTypes.string,
    types: PropTypes.arrayOf(PropTypes.string),
    placeId: PropTypes.string
  });
};

export default addressDataModel;
